var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AntMenu from "antd/es/menu";
export const Menu = (_a) => {
    var { children, className, getPopupContainer } = _a, props = __rest(_a, ["children", "className", "getPopupContainer"]);
    const classes = classNames("gerudo-menu", className);
    return (React.createElement(AntMenu, Object.assign({ className: classes, getPopupContainer: getPopupContainer }, props), children));
};
Menu.defaultProps = {
    selectable: false,
};
Menu.propTypes = {
    children: PropTypes.node,
    mode: PropTypes.oneOf(["vertical", "horizontal", "inline"]),
    selectable: PropTypes.bool,
    onClick: PropTypes.func,
};
Menu.Item = AntMenu.Item;
Menu.SubMenu = AntMenu.SubMenu;
export default Menu;
//# sourceMappingURL=index.js.map